import React from 'react';

import Framework from "@beardeddevops/react.framework";
import {Collections, Objects} from "components";
import {Button} from "reactstrap";

const breadcrumbStatic = [{
	name: "Dispatcher's Time",
	url: '/managers/time_tracking',
	icon: 'dashboard'
}];

export default class DispatcherTimeTracking extends Framework.Components.View {
	constructor(props) {
		super(props);
	}

	render() {
		let {history} = this.props;
		return(
			<div className="container-fluid">
				<Framework.Components.PageBar breadcrumbs={breadcrumbStatic} history={history}/>

				<div className={"row"}>
					<div className={"col"}>
						<Collections.DispatcherTimeTracking history={history} />
					</div>
				</div>
			</div>
		)
	}
}
